import { action, observable } from 'mobx'

import Ds from './ds'

class Contacts {
  @observable all = []
  @observable contacts = []
  @observable contact = []

  @observable ds = new Ds()

  @action loadAllContactsByCompany(companyId, callback) {
    let query = `{
      contacts(
        companyId: ${ companyId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        firstName
        lastName
        title
        email
        phone
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.contacts = data.contacts.map((contact) => {
        contact.fullName = contact.firstName + ' ' + contact.lastName
        return contact
      })

      if (callback) {
        return callback(this.contacts)
      }
    })
  }

  @action loadContact(contactId, callback) {
    let query = `{
      contacts(
        id: ${ contactId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        firstName
        lastName
        title
        email
        phone
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.contact = data.contacts.map((contact) => {
        contact.fullName = contact.firstName + ' ' + contact.lastName
        return contact
      })[0]

      if (callback) {
        return callback(this.contact)
      }
    })
  }

  @action newContact(params, callback) {
    let query = `mutation {
      addContact(
        hash: "${ localStorage.getItem('userHash')}"
        companyId: ${params.companyId},
        firstName: "${params.firstName}",
        lastName: "${params.lastName}",
        title: "${params.title}",
        email: "${params.email}",
        phone: "${params.phone}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        return callback(data)
      }
    })
  }

  @action updateContact(params, callback) {
    let query = `mutation {
      updateContact(
        hash: "${ localStorage.getItem('userHash')}"
        id: ${params.id},
        firstName: "${params.firstName}",
        lastName: "${params.lastName}",
        title: "${params.title}",
        email: "${params.email}",
        phone: "${params.phone}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        return callback(data)
      }
    })
  }

  @action setDefaultContactId(companyId, contactId, callback) {
    let query = `mutation { 
      setDefaultContactId(
        id: ${companyId}, 
        defaultContactId: ${contactId}, 
        hash: "${localStorage.getItem('userHash')}"
      ) { 
          id
        } 
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        return callback(data)
      }
    })
  }

  @action deleteContact(contactId, callback) {
    let query = `mutation {
      deleteContact(
        id: ${contactId},
        hash: "${localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        return callback()
      }
    })
  }
}

export default new Contacts()



// WEBPACK FOOTER //
// ./src/stores/contacts.js